import React from "react";
import Wrapper from "@/scenes/_shared/stages/wrapper";
import useRadioInput, { RadioInput } from "@/components/form/radio-input";
import useDateInput, { DateInput } from "@/components/form/date-input";

const S04 = (props) => {
    const price = useRadioInput({
        name: "sale[car][price]", label: "Hva ble salgssummen?",
        options: {
            data: [
                { label: "0 - 50 000", value: "0-50" },
                { label: "50 000 - 200 000", value: "50-200" },
                { label: "200 000- 500 000", value: "200-500" },
                { label: "500 000 +", value: "500+" },
            ],
        },
        ...props,
    })

    const saleDate = useDateInput({
        name: "sale[car][sold_date]",
        label: "Når ble salget gjennomført?",
        className: "mt-7",
        ...props,
    })

    return (
        <Wrapper {...props} header="Fortell oss om salget">
            <RadioInput {...price.props}/>
            <DateInput {...saleDate.props}/>
        </Wrapper>
    );
};

export default S04;
